<main class="bg-off-white rounded-12px p-24px">
	<app-search-filter
		(toggleFilter)="sidenav.toggle()"
		[searchKey]="'GENERAL_LABELS.SEARCH_WITH_CLIENT_NAME'"
		(keyWord)="pointsFilter.searchText = $event; getHistoryPointsList()"
		[filterCount]="filterCount"
		(resetFilter)="filter.resetFilter()"
	></app-search-filter>
	<div class="mb-24px">
		<app-countries-tabs
			(countryId)="urlParamsChange($event, 'country')"
		></app-countries-tabs>
	</div>
	<div class="mb-24px">
		<app-tabs
			[taps]="tabs"
			(tapChanged)="urlParamsChange($event, 'activeTab')"
			[activeTap]="pointsFilter.activeTab || 1"
		></app-tabs>
	</div>
	<app-points-history-table
		*ngIf="pointsHistoryList?.length"
		[pointsHistoryList]="pointsHistoryList"
		[filter]="pointsFilter"
		[totalCount]="totalCount"
	></app-points-history-table>
	<app-no-data-found *ngIf="!pointsHistoryList?.length"></app-no-data-found>
	<!-- pagination -->
	<div class="mt-8 py-5 max-mobile:overflow-auto">
		<app-pagination
			[totalCount]="totalCount"
			[pageNumber]="pointsFilter.paging.pageNumber"
			[pageCount]="pointsFilter.paging.pageSize"
			(currentPage)="pagingChanged($event, pointsFilter.paging.pageSize)"
			(itemsCountPerPage)="pagingChanged(1, $event)"
		></app-pagination>
	</div>
</main>
<ng-container>
	<mat-sidenav-container [hasBackdrop]="true" class="z-20">
		<mat-sidenav
			position="end"
			#sidenav
			mode="side"
			opened
			class="max-w-[428px] bg-white text-dark-grey p-12px min-h-screen"
			[fixedInViewport]="true"
			[fixedTopGap]="0"
			[disableClose]="false"
			[fixedBottomGap]="0"
			[disableClose]="false"
			[opened]="false"
		>
			<header class="tw-p-4 p-12px">
				<div class="rtl:text-left ltr:text-right">
					<button (click)="sidenav.toggle()">
						<img src="./assets/images/close-square.svg" alt="" />
					</button>
				</div>
			</header>
			<app-points-filter
				#filter
				[pointsFilter]="pointsFilter"
				(emitFilter)="
					pointsFilter = $event; getHistoryPointsList(); sidenav.toggle()
				"
				(emitfilterCount)="filterCount = $event"
			></app-points-filter>
		</mat-sidenav>
	</mat-sidenav-container>
</ng-container>
